/**
 * دکمه‌ی «برنامه‌ی تازه از روی این» روی کارت‌های کشف — قرینه‌ی `SignalDot`ِ
 * موبایل (apps/mobile/src/features/discover/cards.tsx).
 *
 * تا امروز این کار فقط از **داخلِ** صفحه‌ی آیتم شدنی بود، در حالی که روی
 * گوشی از خودِ کارت یک لمس فاصله دارد. همان آیکونِ تقویم+ که تبِ «Plans» و
 * دکمه‌ی «برنامه‌ی جدید» دارند، تا هر سه یک چیز را بگویند.
 *
 * مثل قلب و پرچم، **بیرونِ** لینکِ کارت می‌نشیند و با CSS رویش می‌آید: دکمه
 * داخلِ `<a>` هم HTMLِ نامعتبر است، هم هر کلیک صفحه را هم باز می‌کرد.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccountGate } from '@/features/signup/SignupGate';
import { t } from '@/core/lib/i18n';
import { useSession } from '@/core/session';
import { EventPlusIcon } from '@/ui/icons';
import { setCreatePrefill } from '@/features/signals/createPrefill';
import { useNewSignal } from '@/features/signals/NewSignalGuard';

export function NewPlanButton({ id, title, categoryId, placeName, className }: {
  id: string; title: string; categoryId?: number | null;
  /** مکانِ رخداد — فرم با همین باز می‌شه، نه خالی. «کِی» رو فرم با eventId می‌گیره. */
  placeName?: string | null;
  className?: string;
}) {
  const nav = useNavigate();
  const { session } = useSession();
  const newSignal = useNewSignal();
  const gate = useAccountGate();

  const start = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // همان تصمیمِ صفحه‌ی آیتم: مهمان اول وارد می‌شود و به **همین صفحه**
    // برمی‌گردد، نه یک‌راست به فرم — ورود کلِ صفحه را دوباره لود می‌کند و
    // پیش‌پُرِ ماژولی تا آن‌طرف زنده نمی‌ماند.
    if (!session) {
      // برگه‌ی ثبت‌نام با دلیلش (WHOSUP-308)؛ «عضو شو» به ورود و برگشت به همین‌جا.
      gate('plan', () => undefined);
      return;
    }
    newSignal(() => {
      // دسته و شناسه‌ی رخداد هم می‌روند، عیناً مثلِ گوشی: دسته را کاربر همین
      // حالا انتخاب کرده، و `eventId` نخِ بینِ سیگنال و رخداد است (جزئی از
      // امتیازِ محبوبیت — مایگریشن 0049).
      setCreatePrefill({
        title, categoryId: categoryId ?? undefined, eventId: id,
        placeName: placeName ?? undefined,
      });
      nav('/signal/new');
    });
  };

  return (
    <button type="button" className={`planbtn${className ? ` ${className}` : ''}`}
      aria-label={t('whoIsIn')} title={t('whoIsIn')} onClick={start}>
      <EventPlusIcon size={18} />
    </button>
  );
}
